import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, } from 'react-bootstrap';
import Select from 'react-select';
import { ChooseComponent, useFetch, useTranslation, usePermission } from '@np/np_webcomponentlib'

import { API_OPERATIONS } from '../../shared/consts/api'

import { EntityType, DataEntityType, EntityFormPropsWithType, initEntity, columnsIdrfspecification, columnsIdrfcharacteristictype, optionsEnumStatusDoc, TypeStatusEnum } from './OperationTypes'
import CurrencyInput from 'react-currency-input-field';


// import { ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'






export const OperationFormAmount = ({ title, idInit, handleClose, initEntityProps }: EntityFormPropsWithType) => {

    const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('$component_name');

    const [currentID, setCurrentID] = useState<string | null>(idInit)
    const [amount, setAmount] = useState<number>(0)

    const [exchangeRate, setExchangeRate] = useState<number>(0)
    

    useEffect(() => {
        setCurrentID(idInit)
    }, [idInit])

    const [, doFetchPatchAmount] = useFetch(
        `${API_OPERATIONS}operation/amount`)//{ error: errLoad, isLoading: isLoadLoad, response: respLoad }



    const handleSave = () => {
        
        if (!currentID)
        {return}

        if (!amount)
            {return}

        if (!exchangeRate)
            {return}


        var method = "PATCH"

        const inputData = {
            "idOperation": currentID,
            "amount": amount,
            "exchangeRate": exchangeRate
        }

        
        doFetchPatchAmount({
            method: method,
            "Content-Type": "application/json",
            data: inputData
        }).then(responce => {
            console.log("responce.result.status", responce.result.status)
            if (responce.result.status === "success") {
                handleClose();
            }
            console.log(responce.data)
        })


    }


    const createButtonTitle = useTranslation('createButton')
    const updateButtonTitle = useTranslation('updateButton')



    const [value, setValue] = useState<string | number>('');

    const validateValue =  (_value, name, _values): void => {

        

      setValue(_value);
    
      const newVal = isNaN(_values.float) ? 0 : _values.float;
      setAmount(newVal);
    };


    const [valueER, setValueER] = useState<string | number>('');

    const validateValueER =  (_value, name, _values): void => {

        

      setValueER(_value);
    
      const newVal = isNaN(_values.float) ? 0 : _values.float;
      setExchangeRate(newVal);
    };


    return (<Card>
        <Card.Header>
            <Card.Title as='h4'>{title}</Card.Title>
        </Card.Header>
        <Card.Body className="">
            {/* <Form className="form-horizontal"> */}

            {/* <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('client')}</Form.Label>
                <Col md={9}>




                </Col>
            </Row> */}

<Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('newAmount')}</Form.Label>
                <Col md={9}>
                <CurrencyInput
                id="validationCustom01"
                name="input-1"
                className={`form-control`}
                value={value}
                onValueChange={validateValue}
                placeholder="Новая сумма"
                prefix={''}
                decimalScale={0}
                step={1}
                groupSeparator={' '}
              />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('exchangeRate')}</Form.Label>
                <Col md={9}>
                <CurrencyInput
                id="validationCustom01"
                name="input-1"
                className={`form-control`}
                value={valueER}
                onValueChange={validateValueER}
                placeholder="Курс"
                prefix={''}
                decimalScale={2}
                step={1}
                groupSeparator={' '}
              />
                </Col>
            </Row>


            {/* {canUpdate && currentID !== "" &&
                    <Button onClick={() => { handleSave(); }}> {updateButtonTitle} </Button>
            } */}


            {currentID !== "" &&
                    <Button onClick={() => { handleSave(); }}> {updateButtonTitle} </Button>
            }


        </Card.Body>
    </Card>)
}
